<!--
 * @Author: wangjiaxiang
 * @Date: 2022-07-07 09:47:03
 * @LastEditTime: 2022-07-18 10:55:56
 * @LastEditors: wangjiaxiang
 * @Description: 儿歌故事选择分类弹窗
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/components/chooseSongClassification.vue
 *
-->
<template>
  <div>
    <van-popup v-model="showSong" position="bottom" @click-overlay="clickOverlay" :close-on-click-overlay="false">
      <div class="popup-bg">
        <div class="popup-bg-inner">
          <img  src="../../../../assets/images/babyWikipedia/popup_window_song.png" alt="">
          <p class="title">
            请选择标签
          </p>
          <div class="tags">
            <button :class="songTagActiveId == item.id ? 'button-active' : ''" v-for="(item, index) in tagList" :key="index"
              @click="switchTag(index)">
              {{ item.name }}
            </button>
          </div>
          <div class="btn-close" @click="clickOverlay">
            <button>取消</button>
          </div>

        </div>

      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["showSong", "tagList","songTagActiveId"],
  data() {
    return {};
  },
  methods: {
    clickOverlay() {
      this.$emit("showSongClassification");
    },
    switchTag(name) {
      this.$emit("showSongClassification");
      this.$emit("switchSongTag", name,"弹窗标签");
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .van-popup{
  background: transparent;
}
.van-popup--bottom {
  .popup-bg {
    padding-top: 23px;
    width: 100%;
    .popup-bg-inner{
      position: relative;
      background: #fff;
      border-radius: 16px 16px 0px 0px;
      img{
        position: absolute;
        top: -23px;
        left: 0;
        z-index: 1;
        display: block;
        width: 100%;
      }
      .title {
        position: relative;
        padding: 16px 0 0 16px;
        font-size: 16px;
        z-index: 3;
        font-weight: bold;
        color: #ff67c1;
      }

      .tags {
        position: relative;
        z-index: 2;
        padding: 16px 0;
        margin: 18px auto 0;
        display: flex;
        flex-wrap: wrap;
        border-radius: 11px;
        z-index: 12;
        width: 343px;
        background: #ffffff;

        button {
          margin-left: 15px;
          margin-top: 14px;
          border: none;
          width: 94px;
          height: 34px;
          border-radius: 17px;
          font-size: 14px;
          background: #f7f7f7;
          color: #666666;

          &:nth-child(-n + 3) {
            margin-top: 0;
          }
        }

        .button-active {
          color: #ff67c1;
          font-weight: bold;
          background: #fedbf0;
        }
      }

      .btn-close {
        width: 100%;
        text-align: center;
        padding: 16px 0 24px 0px;

        button {
          width: 343px;
          height: 44px;
          border-radius: 25px;
          border: 1px solid #e9e9e9;
          background: #ffffff;
          color: #333333;
          font-size: 14px;
        }
      }

    }

  }
}
</style>
